import { useState } from "react";

import "./WinnerSubscribe.css";
import { CONFIG } from "../../../../../util/constants";
import { isValidEmail } from "../../../../../util/util";

const { SERVER_API } = CONFIG;

// Email signup for guests. Used on the win screen (guests who just won are the likeliest
// to want tomorrow's puzzle) and in the guest welcome popup.
const WinnerSubscribe = ({
  title = "📬 Get tomorrow's puzzle by email",
  text = "Read the news, then test your memory. One email a day, free.",
  fallbackSource = "win_screen",
  onDone = undefined as undefined | (() => void),
}) => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "sending" | "done" | "error">("idle");
  const valid = isValidEmail(email);

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!valid || status === "sending") return;
    setStatus("sending");
    // Keep the original channel (reddit, tiktok...) when there is one
    const refSource = localStorage.getItem("refSource") || fallbackSource;
    const referralCode = localStorage.getItem("referralCode");
    try {
      const response = await fetch(`${SERVER_API}/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, refSource, referralCode }),
      });
      // 204 means the email was already subscribed - treat as success too
      const ok = response.ok || response.status === 204;
      setStatus(ok ? "done" : "error");
      if (ok && onDone) onDone();
    } catch (err) {
      setStatus("error");
    }
  };

  if (status === "done") {
    return (
      <div className="winner-subscribe" onClick={(e) => e.stopPropagation()}>
        <div className="winner-subscribe-title">📬 You're in!</div>
        <div className="winner-subscribe-text">Check your inbox. Tomorrow's puzzle arrives each morning.</div>
      </div>
    );
  }

  return (
    <form className="winner-subscribe" onSubmit={submit} onClick={(e) => e.stopPropagation()}>
      <div className="winner-subscribe-title">{title}</div>
      <div className="winner-subscribe-text">{text}</div>
      <div className="winner-subscribe-row">
        <input
          type="email"
          inputMode="email"
          autoComplete="email"
          placeholder="you@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={status === "sending"}
        />
        <button type="submit" disabled={!valid || status === "sending"}>
          {status === "sending" ? "…" : "Subscribe"}
        </button>
      </div>
      {status === "error" && <div className="winner-subscribe-error">Something went wrong. Try again?</div>}
    </form>
  );
};

export default WinnerSubscribe;
